<div class="card bg-light border-0 rounded h-100 intro-card">
	<div class="card-body">
		<div *ngIf="heading || icon" class="card-title">
			<div *ngIf="icon" class="d-flex align-items-center">
				<figure class="me-1 mb-0">
					<img [src]="icon" alt="" />
				</figure>

				<h3 *ngIf="heading" class="mb-0">{{ heading }}</h3>
			</div>
		</div>

		<div class="card-content">
			<ng-content></ng-content>
		</div>
	</div>
</div>
